var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:{[`width-${_vm.width}`]: true, [`height-${_vm.height}`]: true }})
}
var staticRenderFns = []

export { render, staticRenderFns }